import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-registration-success',
  imports: [TranslocoModule, RouterModule],
  templateUrl: './registration-success.component.html',
  styleUrl: './registration-success.component.scss',
})
export class RegistrationSuccessComponent {}
